module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm2"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("The Author’s stories have appeared also in periodicals and anthologies as indicated:")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“Usher.”"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary,")]), _vm._v(" Feb. 1956.")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“The Penny Is for God!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Chicago Jewish Forum.")]), _vm._v(" Sept. 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“Tessie, Don’t Give Away the Raisin; without It, You’re Lost!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn Literary Review,")]), _vm._v(" No. 5, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“Free the Canaries from Their Cages!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary,")]), _vm._v(" Sept. 1955; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Best American Short Stories of 1956,")]), _vm._v(" edited by Martha Foley (Boston: Houghton Mifflin Company, 1956); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prize Stories of 1957")]), _vm._v(" (The O’Henry Memorial Awards), edited by Paul Engle and Constance Urdang (Garden City, N.Y.: Doubleday and Company, Inc., 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“No Golden Tombstones for Me!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary,")]), _vm._v(" Nov. 1956.")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“They’re Killing Jews on Sackman Street!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Midstream,")]), _vm._v(" Autumn 1956; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Chosen,")]), _vm._v(" edited by Harold U. Ribalow(London, New York: Abelard-Schuman, Ltd., 1959); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Midstream Anthology")]), _vm._v(" edited by Shlomo Katz, (New York, London: Thomas Yoseloff. I960).")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“Fire Is Burning on Our Street!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Midstream,")]), _vm._v(" Sept. 1964.")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“Come into the Hallway, for Five Cents!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Commentary,")]), _vm._v(" July 1960; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Name Aloud,")]), _vm._v(" edited by Harold U. Ribalow, Thomas Yoseloff (New York. London. 1969).")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“Hello. Lenin! Hello. Stalin! How’s the Revolution Today?” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The National Jewish Monthly,")]), _vm._v(" March 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“Songs My Mother Taught Me That Are Not in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hamlet;")]), _vm._v(" or, ‘Come into My House, Horatio! There Are More Things under the Mattress than Are Dreamt of in Your Philosophy!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn Literary Review,")]), _vm._v(" No. 4, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“I Went to the Market Place to See the World! Oy, Mama, Oy!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Mizrachi Woman,")]), _vm._v(" May 1969.")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("“With a Herring in One Hand and a Bottle of Schnapps in the Other; Oh! How He Did Dance!” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brooklyn Literary Review,")]), _vm._v(" No. 6, 1984.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcbcd76a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_FrontMatter.vue
// module id = 69
// module chunks = 0